export default {
  "gameActions.title": "Game Actions",
  "gameActions.thead.actionId": "ActionId",
  "gameActions.thead.betOrderno": "BetOrderno",
  "gameActions.thead.actionCode": "ActionCode",
  "gameActions.thead.userNo": "UserNo",
  "gameActions.thead.email": "Email",
  "gameActions.thead.amount": "Amount",
  "gameActions.thead.gameName": "GameName",
  "gameActions.thead.providerName": "ProviderName",
  "gameActions.thead.firstName": "FirstName",
  "gameActions.thead.lastName": "LastName",
  "gameActions.thead.nickName": "NickName",
  "gameActions.thead.createTime": "CreateTime",
  "gameActions.action.details": "Details",
  "gameActions.action.providerDetails": "Provider Details",
  "gameActions.tooltip.copy.userNo": "Copy UserNo: {text}",
  "gameActions.tooltip.showUserDetails": "Show User Details",
  "gameActions.tooltip.copy.betOrderno": "Copy BetOrderno: {text}",
  "gameActions.tooltip.copy.actionId": "Copy ActionId: {text}",
  "gameActions.tooltip.copy.email": "Copy Email: {text}",
  "gameActions.copy.success": "Copied to clipboard",
};